import {
  beAccountSettingsGetUserSetting,
  beAccountSettingsUpsertUserSettings
} from 'Api/beAccountSettingsApi'
import {
  beSendGetSenderStatus,
  beSendRegisterSender,
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED
} from 'Api/beSendApi'
import { LOGIN_TYPE_WEBLOGIN } from 'Constants/'
import { STORE_KEY_LOGIN_TYPE, storeGet } from 'mailup-react-helpers'

export async function fetchStatus(newValue, cancelToken) {
  const result = await beSendGetSenderStatus(newValue, 'CON', cancelToken)

  return result !== null ? result.Status : TRUSTED_SENDER_STATUS_NOT_CONFIRMED
}

export async function fetchHideDelivStatus(email) {
  const result = await beAccountSettingsGetUserSetting(
    0,
    `HideDeliverabilityStatus-${email}`
  )

  return result ? result.DataValue === true : false
}

export async function registerSender(email, cancelToken) {
  const result = await beSendRegisterSender(email, 'CON', 0, cancelToken)

  return result
}

export async function setHideDelivStatus(email) {
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  if (loginType === LOGIN_TYPE_WEBLOGIN) {
    await beAccountSettingsUpsertUserSettings(
      0,
      `HideDeliverabilityStatus-${email}`,
      true
    )
  }
}
